import classNames from 'classnames';

interface QuestionTimerProps {
    secondsRemaining: number;
    progress: number;
    size?: 'sm' | 'lg';
}

const ringRadius = 44;
const ringCircumference = 2 * Math.PI * ringRadius;

const QuestionTimer: React.FC<QuestionTimerProps> = ({ secondsRemaining, progress, size = 'lg' }) => {
    const isUrgent = secondsRemaining <= 5;
    const dimension = size === 'lg' ? 'w-28 h-28' : 'w-16 h-16';

    return (
        <div className={classNames('relative shrink-0', dimension)}>
            <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
                <circle cx="50" cy="50" r={ringRadius} fill="none" strokeWidth="8" className="stroke-slate-200 dark:stroke-slate-700" />
                <circle
                    cx="50"
                    cy="50"
                    r={ringRadius}
                    fill="none"
                    strokeWidth="8"
                    strokeLinecap="round"
                    strokeDasharray={ringCircumference}
                    strokeDashoffset={ringCircumference * (1 - Math.max(0, Math.min(1, progress)))}
                    className={classNames('transition-[stroke-dashoffset] duration-200 ease-linear', {
                        'stroke-rose-500': isUrgent,
                        'stroke-teal-500': !isUrgent,
                    })}
                />
            </svg>
            <div
                className={classNames('absolute inset-0 flex items-center justify-center font-bold tabular-nums', {
                    'text-3xl': size === 'lg',
                    'text-lg': size === 'sm',
                    'text-rose-600 dark:text-rose-400': isUrgent,
                    'text-slate-900 dark:text-white': !isUrgent,
                })}
            >
                {secondsRemaining}
            </div>
        </div>
    );
};

export default QuestionTimer;
